export default "__VITE_ASSET__DEBCvIhS__"